import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map } from 'rxjs';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-task-comment',
  templateUrl: './task-comment.component.html',
  styleUrls: ['./task-comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TaskCommentComponent {
  comments$ = this.store('lastRoundQaFeedbacks').$.pipe(
    map((feedbacks) =>
      feedbacks
        .map((feedback) => feedback.comment)
        .filter((comment) => comment),
    ),
  );

  constructor(private store: TaskWorkspaceStore) {}
}
